import React, { useEffect, useState, useRef } from 'react';
import M from 'materialize-css/dist/js/materialize';
import { translate } from '../../utils/util';

const ModalBottomSheetUI = (props) => {
    const modal = useRef();
    const [instanceM, setinstanceM] = useState();

    useEffect(() => {
        var instance = M.Modal.init(modal.current, {
            dismissible: true,
            onCloseEnd: () => close(),
        });
        setinstanceM(instance);
        // eslint-disable-next-line
    }, [modal]);

    useEffect(() => {
        if (props.open) {
            show();
        }
        // eslint-disable-next-line
    }, [props.open]);

    const close = () => {
        if (props.onClose) {
            props.onClose();
        }

        if (instanceM) {
            instanceM.close();
        }
    }

    const show = () => {
        if (instanceM) {
            instanceM.open();
        }
    }

    return (
        <div id={'modal1'} ref={modal} className="modal bottom-sheet" style={{ maxHeight: props.maxHeight || '45%' }}>
            <div className="modal-content">
                {props.header && <h4>{props.header}</h4>}
                {props.data}
            </div>
            <div className="modal-footer">
                <button
                    className="btn btn-principal waves-effect waves-light"
                    onClick={close}
                    type="button">{props.btnCancel ? props.btnCancel : translate('general:close')}</button>

            </div>
        </div>

    );
};

export default ModalBottomSheetUI;